import { withKeycloak } from "@react-keycloak/web";
import React from "react";
import { labels } from "../../../../../localization/labels";
import LifeCycleHistoryLogService from "../../../../../services/LifeCycleHistoryLogService";
import TableUtils from "../../../../core/Table/TableUtils";
import TableComponent from "../../../page/TableComponent";
import LifeCycleHistoryLog from "./LifeCycleHistoryLog";

class LifeCycleHistoryLogContainer extends TableComponent {
  constructor(props) {
    super(props);
    this.lifeCycleHistoryLogService = new LifeCycleHistoryLogService(
      this.keycloak
    );
  }

  componentDidUpdate() {
    super.componentDidUpdate();
    if (this.props.reload && this._isMounted) {
      this.props.resetReloading();
      this.startLoading(this.state.pageInfo, this.sortInfo);
    }
  }

  loadData = pageInfo => {
    const entity = this.props.entity;
    if (entity?._links) {
      const url = entity._links.lifeCycleHistoryLogsCompactView.href;
      const sortInfo = {
        orderBy: "id",
        direction: "desc"
      };
      this.prepareCall(
        this.lifeCycleHistoryLogService.getEntitiesWithParams(
          url,
          pageInfo,
          sortInfo,
          this.onLifeCycleHistoryLogLoad,
          this.messageHandler.handleError
        )
      );
      this.performCalls();
    }
  };

  onLifeCycleHistoryLogLoad = data => {
    this.onDataLoad(data);
  };

  columns = [
    {
      dataField: "previousLifeCycle",
      text: labels.previousLifeCycle,
      formatter: TableUtils.textFormatter
    },
    {
      dataField: "currentLifeCycle",
      text: labels.currentLifeCycle,
      formatter: TableUtils.textFormatter
    },
    {
      dataField: "party",
      text: labels.changedBy,
      formatter: TableUtils.textFormatter
    },
    {
      dataField: "transitionDate",
      text: labels.date,
      formatter: TableUtils.dateFormatter
    }
  ];

  possibleSizesPerPage() {
    return [3, 5, 10];
  }

  render() {
    return <LifeCycleHistoryLog {...this.renderProps()} />;
  }
}

export default withKeycloak(LifeCycleHistoryLogContainer);
